import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const HistoricRoutesPage = lazy(() => import('@pages/autoschedule/HistoricRoutesPage'));

// Route Component using PageWrapper approach
const HistoricRoutesRouteContainer = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('historic-routes-page-title')}>
        <HistoricRoutesPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default { HistoricRoutesRouteContainer };
